"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const CompRegoNotOpenYet_greyIcon = createIcon({
  displayName: "CompRegoNotOpenYet_greyIcon",
  viewBox: "0 0 42.36 33.02",
  path: (
    <>
      <path
        d="M16.49,16.53c-2.27,0-4.2-.8-5.83-2.43-1.61-1.61-2.43-3.57-2.43-5.83s.8-4.2,2.43-5.83c1.61-1.61,3.57-2.43,5.83-2.43s4.2.8,5.83,2.43c1.63,1.63,2.43,3.57,2.43,5.83s-.8,4.2-2.43,5.83-3.57,2.43-5.83,2.43ZM0,33.02v-5.77c0-1.17.31-2.25.91-3.22.6-.99,1.4-1.73,2.39-2.25,2.12-1.07,4.29-1.86,6.49-2.39,2.21-.54,4.43-.8,6.7-.8s4.49.27,6.7.8,4.37,1.34,6.49,2.39c.99.52,1.79,1.26,2.39,2.25.6.99.91,2.06.91,3.22v5.77H0ZM4.12,28.9h24.73v-1.65c0-.37-.1-.72-.29-1.03-.19-.31-.43-.56-.74-.72-1.85-.93-3.73-1.63-5.63-2.08-1.9-.45-3.79-.7-5.73-.7s-3.83.23-5.73.7c-1.9.47-3.77,1.15-5.63,2.08-.31.16-.56.41-.74.72-.19.31-.29.66-.29,1.03v1.65h.04ZM16.49,12.41c1.13,0,2.1-.41,2.91-1.22.8-.8,1.22-1.77,1.22-2.91s-.41-2.1-1.22-2.91c-.8-.8-1.77-1.22-2.91-1.22s-2.1.41-2.91,1.22c-.8.8-1.22,1.77-1.22,2.91s.41,2.1,1.22,2.91c.8.8,1.77,1.22,2.91,1.22Z"
        fill="currentColor"
      />
      <path
        d="M40.91,7.77v-1.65h1.44v-2.47h-12.57v2.47h1.44v1.65c0,.82.19,1.59.58,2.31.27.49.62.93,1.03,1.3-.41.37-.76.8-1.03,1.3-.39.72-.58,1.48-.58,2.31v1.65h-1.44v2.47h12.57v-2.47h-1.44v-1.65c0-.82-.19-1.59-.58-2.31-.27-.49-.62-.93-1.03-1.3.41-.37.76-.8,1.03-1.3.39-.72.58-1.48.58-2.31ZM33.7,16.63v-1.65c0-.66.23-1.22.7-1.67.93-.95,2.41-.95,3.34,0,.47.45.7,1.01.7,1.67v1.65h-4.74Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
    color: "gray.500",
  },
});

export default CompRegoNotOpenYet_greyIcon;
